import React from 'react';

import ErrorMessage from '../ErrorMessage/ErrorMessage';
import { GENERIC_ERROR_MESSAGE } from '../../../stores/constants';
import styles from './ErrorFallback.module.scss';

const ErrorFallback: React.FC = () => {
    return (
        <div className={styles.wishListsErrorContainer}>
            <ErrorMessage hasError={true} message={GENERIC_ERROR_MESSAGE} />
        </div>
    );
};

export default ErrorFallback;
